import { render, staticRenderFns } from "./FormSubscriptions.vue?vue&type=template&id=ef715c02&scoped=true"
import script from "./FormSubscriptions.vue?vue&type=script&lang=js"
export * from "./FormSubscriptions.vue?vue&type=script&lang=js"
import style0 from "./FormSubscriptions.vue?vue&type=style&index=0&id=ef715c02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef715c02",
  null
  
)

export default component.exports